
import { useProject } from '@/hooks/useProject'
import SubscriptionPeriodSelect from '@/modules/marketplace/components/billing/SubscriptionPeriodSelect.vue'
import TariffCard from '@/modules/marketplace/components/billing/TariffCard.vue'
import { computed, defineComponent, onMounted, ref } from 'vue'
import { useBillingStore } from '../../../../../store/stores/billing'
import TariffIntegrationsTable from '../TariffIntegrationsTable.vue'
import TariffRadioGroup from '../TariffRadioGroup.vue'
import TariffStateHeader from '../tariffStateHeader/TariffStateHeader.vue'
import { useTariffTrialRestrictions, isTrialAllowedTariff } from '@/hooks/useTariffTrialRestrictions'
export default defineComponent({
    components: { TariffCard, TariffRadioGroup, TariffIntegrationsTable, SubscriptionPeriodSelect, TariffStateHeader },
    props: {},
    setup(props, { emit }) {
        const { project } = useProject()
        const billingStore = useBillingStore()
        const { isTrialRestricted } = useTariffTrialRestrictions()
        const tariffOrder: Record<string, number> = {
            tariff1: 1,
            tariff2: 2,
            tariff3: 3,
        }
        const sortedTariffs = computed(() => {
            const sorted = [...(billingStore.tariffs || [])].sort((a, b) => {
                const left = tariffOrder[a.id] ?? Number.MAX_SAFE_INTEGER
                const right = tariffOrder[b.id] ?? Number.MAX_SAFE_INTEGER
                return left - right
            })
            // На пробном тарифе показываем только доступные тарифы (Умный бот и tariff3), кроме суперпользователя.
            return isTrialRestricted.value ? sorted.filter(isTrialAllowedTariff) : sorted
        })
        const loading = ref(true)
        onMounted(async () => {
            if (billingStore.getCurrentTariff(project.value.id)) return
            loading.value = true
            await Promise.all([
                billingStore.fetchCurrentTariff(project.value.id),
                billingStore.fetchTariffs(project.value.id),
            ])

            loading.value = false
        })
        return { billingStore, sortedTariffs }
    },
})
